import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  container: {
    minHeight: "100vh",
  },
}));

export default useStyles;
